import React, { FunctionComponent } from "react";

const LoginLayout: FunctionComponent = ({ children }) => {
  return <main className="flex flex-row h-screen">{children}</main>;
};

export default LoginLayout;
